import React from 'react'
import {InfoFieldValue} from './InfoFieldValue'
import {InfoFieldTitle} from './InfoFieldTitle'
import classes from './styles.module.scss'

interface InfoFieldProps {
  title: string
  value: string
  link?: boolean
}

export const InfoField: React.FC<InfoFieldProps> = ({link, title, value}) => {
  return (
    <div className={classes.infoFiledWrapper}>
      <InfoFieldTitle title={title}/>
      <InfoFieldValue value={value} link={link}/>
    </div>
  )
}
